
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAircraftDroneMedium as ObiAircraftDroneMediumElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-aircraft-drone-medium.js';
 
 
 

 
 export const ObiAircraftDroneMedium = createComponent({
   react: React,
   tagName: 'obi-aircraft-drone-medium',
   elementClass: ObiAircraftDroneMediumElement,
   events: {
     
   }
  });
 
 